import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import { Table, Button } from 'react-bootstrap';
import { pencil2 } from 'react-icons-kit/icomoon/pencil2';
import swal from 'sweetalert';
import SvgIcon from 'react-icons-kit';
import ModalAuthorization from '../refuses/components/ModalAuthorization';

class ModalIncidents extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.removeRefuse = this.removeRefuse.bind(this);
		this.editAuth = this.editAuth.bind(this);

		this.state = {
		    show: false,
		    id_refuse:"",
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}
	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow(donor_id) {
		this.setState({ show: true});
	}

	removeRefuse(e, id){
		this.setState({
			id_refuse:""
		})

		swal({
	        title: 'Confirmación',
	        text: '¿Desea quitar el candado?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Quitar!',
	        cancelButtonText: '¡No, Cancelar!',
	        //closeOnConfirm: true,
	        closeOnCancel: true
	    }, (isConfirm)=>{
			if(isConfirm === true){
				this.setState({
					id_refuse:id
				})
				
				this.editAuth();
				
			}
		});
	}

	editAuth(){
		this.modal_authorization.handleShow('clinic');
	}


	render(){
		const { t } = this.props;
		
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_incidents.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{padding:"0px 20px 0px 20px"}}>
				        <Table responsive hover>
				          <thead>
				            <tr>
				              <th>{t('content.modal_incidents.reason')}</th>
				              <th></th>
				            </tr>
				          </thead>
				          <tbody>
				        	{this.props.incidents.map( (item, index) => (
				        		item.id !== 0 ?
		          					<tr key={index}>
						                <td>{item.reason}</td>
						                <td>
											<Button className="btn btn-info btn-xs" title="Editar" 
												onClick={(e)=>this.removeRefuse(e, item.id)}
												disabled={!this.props.task_release_lock.update}>
												<SvgIcon icon={pencil2} />
											</Button>
										</td>
						        	</tr>
					        	: null
				            ))}
				          </tbody>
				        </Table>

				        <ModalAuthorization {...this.props} 
							id_refuse={this.state.id_refuse} 
							closing={this.handleClose}
							onRef={ref => (this.modal_authorization = ref)} />
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalIncidents) 